import 'slick-carousel'

export default (() => {
  $('.js-image-slider').each(function () {
    var imageSlider = $(this)
    imageSlider.slick({
      adaptiveHeight: true,
      dots: true,
      prevArrow: $(this).parent().find('.image-slider-previous'),
      nextArrow: $(this).parent().find('.image-slider-next')
    })
  })
})()
